import { useParams, useNavigate } from "react-router-dom";
import React, {
	useState,
	useContext,
	useEffect,
	memo,
	forwardRef,
} from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AppContext } from "../../../../context/AppContext";
import Swal from "sweetalert2";
import axios from "axios";
import GetToken from "../../../../GetToken";
import { handleInvalidToken } from "../../../../AuthUtils";
import AnimationSpinner from "../../../../AnimationSpinner";
import indexImage1 from "../../../../assets/images/index-images/1.jpg"
import indexImage3 from "../../../../assets/images/index-images/3.jpg"
import indexImage4 from "../../../../assets/images/index-images/4.jpg"
import indexImage6 from "../../../../assets/images/index-images/6.jpg"
import indexImage7 from "../../../../assets/images/index-images/7.jpg"
import indexImage8 from "../../../../assets/images/index-images/8.jpg"
import indexImage9 from "../../../../assets/images/index-images/9.jpg"
import indexImage10 from "../../../../assets/images/index-images/10.jpg"

const IndexTemplate = memo(
	forwardRef(({ index_page, indexItems }, ref) => {
		const getTemplateByIndex = (index_page) => {
			switch (index_page) {
				case 2:
					return (
						<div className="page" style={ {backgroundImage: `url(${indexImage1})`}}>
							<div className="page-content">
								<div className="container">
									<h1
										className="display-6 fw-bold mb-4 text-center"
										style={{ fontFamily: "Arial, sans-serif" }}
									>
										INDEX
									</h1>
									<div className="d-flex flex-column gap-1">
										{indexItems.map((item, idx) => (
											<div
												key={idx}
												className="border border-1 border-primary rounded d-flex align-items-center p-2"
												style={{ cursor: "pointer" }}
											>
												<div
													className="ps-2 pe-4 fw-bold"

												>
													{item.chapter_title}
												</div>
											</div>
										))}
									</div>
								</div>
							</div>
						</div>
					);

				case 8:
					return (
						<div className="page" style={ {backgroundImage: `url(${indexImage7})`}}>
							<div className="page-content">
							<div className="container index-2 py-4">
								<h2 className="display-5 mb-4">INDEX</h2>
								<div className="row">
									{indexItems.map((item, idx) => (
										<div key={idx} className="col-md-6 mb-3 index-2-col">
											<div className="card style2">
												<div className="card-body">
													{item.chapter_title}
												</div>
											</div>
										</div>
									))}
								</div>
							</div>
						</div>
						</div>
					);

				case 1:
					return (
						<div className="page" style={ {backgroundImage: `url(${indexImage4})`}}>
							<div className="page-content">
						<div className="container-fluid  py-5 pt-3">
							<h3 className="text-primary mb-3">INDEX</h3>
							<ul className="list-group list-group-3">
								{indexItems.map((item, idx) => (
									<li
										key={idx}
										className="list-group-item d-flex justify-content-between align-items-center"
									>
										{item.chapter_title}
									</li>
								))}
							</ul>
						</div>
						</div>
						</div>
					);

				case 3:
					return (
						<div className="page" style={ {backgroundImage: `url(${indexImage10})`}}>
							<div className="page-content">
						<div className="container py-3">
							<h4 className="text-center text-muted mb-4">INDEX</h4>
							<ul className="list-group list-group-4">
								{indexItems.map((item, idx) => (
									<li
									key={idx}
									className="list-group-item d-flex justify-content-between align-items-center"
								>
									{item.chapter_title}
								</li>
								))}
								</ul>
							</div>
						</div>
						</div>
					);

				case 4:
					return (
						<div className="page" style={ {backgroundImage: `url(${indexImage8})`}}>
							<div className="page-content">
						<div className="container py-4">
							<h5 className="text-uppercase mb-4">INDEX</h5>
							<div className="table-responsive index-5">
								<table className="table table-hover">
									<tbody>
										{indexItems.map((item, idx) => (
											<tr key={idx}>
										
												<td>{item.chapter_title}</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
						</div>
						</div>
					);

				case 5:
					return (
						<div className="page" style={ {backgroundImage: `url(${indexImage3})`}}>
							<div className="page-content">
						<div className="container py-5 index-6">
							<h6 className="text-center  display-6 mb-4">INDEX</h6>
							{indexItems.map((item, idx) => (
								<div
									key={idx}
									className="d-flex title-box align-items-center mb-2 "
								>
									
									<div className="h5 title mb-0">{item.chapter_title}</div>
								</div>
							))}
						</div>
						</div>
						</div>
					);

				case 6:
					return (
						<div className="page" style={ {backgroundImage: `url(${indexImage6})`}}>
							<div className="page-content">
						<div className="container index-7 py-4">
							<div className="text-center mb-4">
								<span className="border-bottom border-3 pb-2"style={{fontSize:"30px"}}>INDEX</span>
							</div>
							<div className="row g-1">
								{indexItems.map((item, idx) => (
									<div key={idx} className="col-12">
										<div className=" p-2 style7 rounded">
											<div className="d-flex align-items-baseline">
												
												<div className="h5" style={{fontSize:"16px"}}>{item.chapter_title}</div>
											</div>
										</div>
									</div>
								))}
							</div>
						</div>
						</div>
						</div>
					);

				case 7:
					return (
						<div className="page" style={ {backgroundImage: `url(${indexImage9})`}}>
							<div className="page-content">
						<div className="container-fluid index-8 py-5 ">
							<div className="container">
								<h2 className="text-center mb-4">INDEX</h2>
								<div className="row row-cols-1 row-cols-md-2 g-3">
									{indexItems.map((item, idx) => (
										<div key={idx} className="col ">
											<div className="border style8 border-light p-3 rounded" style={{height:"140px"}}>
												<div className="d-flex justify-content-between">
													
													<span style={{fontSize:"14px"}}>{item.chapter_title}</span>
												</div>
											</div>
										</div>
									))}
								</div>
							</div>
							</div>
							</div>
						</div>
					);

				default:
					return (
						<div className="container py-5">
							<div className="alert alert-warning">Invalid template index</div>
						</div>
					);
			}
		};

		return <div ref={ref}>{getTemplateByIndex(index_page)}</div>;
	}),
	(prevProps, nextProps) =>
		prevProps.index_page === nextProps.index_page &&
		prevProps.indexItems === nextProps.indexItems
);

export default IndexTemplate;
